import type { PageContext } from '@zto/zpage-runtime'
import { commonOptions, SysConfigPaths, YesNo } from '@/config'

export function roomDialog(isEdit: boolean) {
  return {
    width: 760,
    labelWidth: 130,
    itemSpan: 24,
    title: isEdit ? '编辑房间' : '添加房间',
    onShow: async ({ app, data }: PageContext) => {
      if(!isEdit) return
      const id = data?.id
      const detail = await app.request({
        api: '/sys/admin/api/region/room/detail',
        method: 'POST',
        params: { id }
      })
      console.info('🚀 ~ file:_dialogs method:onShow line:19 ----- detail', detail)
      return {
        payload: {
          ...detail,
        }
      }
    },
    formItems: [
      {
        type: 'text',
        prop: 'roomCode',
        label: '房间编号',
        visibleOn: `${isEdit}`
      },
      {
        type: 'fuzzy-select',
        prop: 'communityCode',
        labelProp: 'communityName',
        label: '所属小区',
        optionValueProp: 'communityCode',
        optionLabelProp: 'communityName',
        triggerFocus: true,
        required: true,
        remote: true,
        keywordProp: 'communityName',
        api:'/sys/admin/api/region/community/pageList',
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            disabled: !!isEdit,
          }
        }
      },
      {
        type: 'fuzzy-select',
        prop: 'buildingCode',
        label: '选择楼栋',
        optionValueProp: 'buildingCode',
        optionLabelProp: 'buildingName',
        triggerFocus: true,
        required: true,
        remote: true,
        keywordProp: 'buildingName',
        api: '/sys/admin/api/region/building/pageList',
        // labelTpl: '${buildingName}-${unitName}', // 选中的格式化
        labelProp: 'buildingName',
        placeholder: '请先选择小区',
        autoHeight: true,
        collapseTags: false,
        multipleLimit: 100,
        dynamicAttrs: ({ data }: PageContext) => ({
          multiple: !isEdit, // 编辑时 单选
          apiParams: { communityCode: data.communityCode },
          disabled: data.communityCode == null,
          optionLabelPropFormatter: (item: any) => {
            return `${item.buildingName || data.buildingName}${item.unitName || data.unitName}`
          },
          onChange: async (model: any, val: any, ctx: PageContext, ext: any) => {
            // console.info('🚀 ~ file:_dialogs_dialogs method:onChange line:97 ----- model', model)
            // model.buildingNumber = ext.option.buildingNumber
          }
        })
      },
      {

        type: 'fuzzy-select',
        prop: 'houseNumber',
        label: '户型号',
        remote: true,
        keywordProp: 'fuzzyName',
        api: '/sys/admin/config/dictItems',
        apiParams: {
          dictPath: SysConfigPaths.ROOM_DICT,
        },
        // labelProp: 'name',
        optionValueProp: 'name',
        optionLabelProp: 'name',
        triggerFocus: true,
        autoHeight: true,
        collapseTags: false,
        multipleLimit: 20,
        visibleOn: `${!isEdit}`,
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            required: !isEdit,
            multiple: !isEdit, // 编辑时 单选
            onChange: async (model: any, val: any, ctx: PageContext, ext: any) => {
              if (ext.options) {
                model.roomList = ext.options.map((item: any) => {
                  return {
                    // roomName: item.name,
                    houseNumber: item.name
                  }
                })
              }
            }
          }
        }
      },
      {
        type: 'input',
        prop: 'floorName',
        label: '楼层',
        trim: true,
        maxlength: 10,
        visibleOn: `${isEdit}`,
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            required: !!isEdit,
          }
        },
      },
      {
        type: 'input',
        prop: 'floorNumber',
        label: '楼层通信码',
        trim: true,
        maxlength: 10,
        visibleOn: `${isEdit}`,
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            required: !!isEdit,
          }
        }
      },
      {
        type: 'input',
        prop: 'roomName',
        label: '房间号',
        trim: true,
        maxlength: 10,
        visibleOn: `${isEdit}`,
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            required: !!isEdit,
          }
        },
      },
      {
        type: 'input',
        prop: 'roomNumber',
        label: '房间通信码',
        trim: true,
        maxlength: 10,
        visibleOn: `${isEdit}`,
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            required: !!isEdit,
          }
        },
      },

      {
        type: 'input-number',
        prop: 'startFloor',
        label: '起始楼层',
        min: 1,
        max: 100,
        precision: 0,
        visibleOn: `${!isEdit}`,
        span: 12,
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            required: !isEdit,
            max: data.endFloor ?? 100
          }
        }
      },
      {
        type: 'input-number',
        prop: 'endFloor',
        label: '终点楼层',
        min: 1,
        max: 100,
        precision: 0,
        visibleOn: `${!isEdit}`,
        span: 12,
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            required: !isEdit,
            min: data.startFloor ?? 1
          }
        }
      },
      {
        type: 'checkbox',
        checkType: 'radio',
        prop: 'isDeliverable',
        label: '是否可配送',
        options: commonOptions.yesOrNo,
        default: YesNo.YES,
        required: true
      }
    ],
    beforeSubmit: async ({ app, data }: PageContext, model: any, options: any) => {
      const { startFloor, endFloor, buildingCode, houseNumber, ...other } = data || {}
      console.info('🚀 ~ file:_dialogs method:beforeSubmit line:210 ----- data', data)
      const { Message } = app.useMessage()
      if (startFloor > endFloor) {
        Message.warning('起始楼层不能大于终点楼层')
        return false
      }
      // 新增
      if(!isEdit){
        return {
          startFloor,
          endFloor,
          buildingCodeList: buildingCode,
          ...other
        }
      }
      const { id, communityCode, roomNumber,  roomName ,floorName, floorNumber, isDeliverable  } = other || {}
      const payload = {
        id,
        buildingCode,
        houseNumber,
        communityCode,
        roomNumber,
        roomName ,
        floorName,
        floorNumber,
        isDeliverable
      }
      // console.info('🚀 ~ file:_dialogs method:beforeSubmit line:133 ----- payload', payload)
      return payload
    },
    actions: {
      close: {},
      submit: { label: '确定' }
    }
  }
}

export function batchUpdateDeliverDialog() {
  return {
    width: 420,
    labelWidth: 120,
    itemSpan: 24,
    title: '批量编辑是否可配送',
    formItems: [
      {
        type: 'checkbox',
        checkType: 'radio',
        prop: 'isDeliverable',
        label: '是否可配送',
        options: commonOptions.yesOrNo,
        default: YesNo.YES,
        required: true
      }
    ],
    actions: {
      close: {},
      submit: { label: '确定' }
    }
  }
}
